import { RequestStatus } from 'features/request/requestSlice';
import type { CatalogItemData } from 'gql/graphql';
import { useContractCatalog } from 'pages/Project/UerProject/Contract/hooks/useContractCatalog';
import { cnMixSpace, Select, Text } from 'uikit';

import { useCallback, useMemo } from 'react';

import Styles from './catalogSelect.module.css';

type TItem = Partial<CatalogItemData>;

interface ICatalogSelectProps {
    selectValue: TItem | undefined;
    isDisabled: boolean;
    onChange: (value: TItem) => void;
}
const getLabel = (item: TItem | undefined) => item?.name ?? '';
const getKey = (item: TItem | undefined) => item?.uniqueId ?? '';

export const ContractCatalogSelect = ({ selectValue, onChange, isDisabled }: ICatalogSelectProps) => {
    const { items, status } = useContractCatalog();

    const isLoading = useMemo(() => status === RequestStatus.FETCHING, [status]);

    const currentItem = useMemo(
        () => items?.find((i) => i.uniqueId === selectValue?.uniqueId),
        [items, selectValue?.uniqueId],
    );

    const onChangeSelect = useCallback(
        ({ value }: { value: TItem | null }) => {
            if (value) {
                onChange(value);
            }
        },
        [onChange],
    );

    return (
        <>
            <Text size="s" className={cnMixSpace({ mB: 'm' })}>
                Справочник расценок:
            </Text>
            <Select
                items={items}
                value={currentItem}
                onChange={onChangeSelect}
                isLoading={isLoading}
                getItemLabel={getLabel}
                getItemKey={getKey}
                size="s"
                placeholder="Выберите"
                disabled={isDisabled}
                className={Styles.catalogSelect}
            />
        </>
    );
};

ContractCatalogSelect.displayName = 'ContractCatalogSelect';
